import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import style from './Bounties.module.css';
import { Oval } from 'react-loader-spinner';
import BountyTile from '../../../Components/BountyTile/BountyTile';
import axios from 'axios';

const Bounties = () => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('curUser'));
  const { bounty, loading, success } = useSelector(
    (state) => state.getAllBountyReducer
  );

  useEffect(() => {
    const fetchAll = async () => {
      dispatch({ type: 'GET_ALL_BOUNTY_REQUEST' });
      try {
        const res = await axios.get('/bounty/admin/all', {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${user?.token}`,
          },
          withCredentials: true,
        });
        dispatch({ type: 'GET_ALL_BOUNTY_SUCCESS', payload: res.data.bounties });
      } catch (err) {
        dispatch({ type: 'GET_ALL_BOUNTY_ERROR', payload: err });
      }
    };
    fetchAll();
  }, [dispatch]);

  return (
    <>
      <h1 style={{ color: 'rgb(206, 144, 206)' }}>Bounties</h1>
      <div className={style.Bounties}>
        {loading ? (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        ) : bounty && bounty.length !== 0 ? (
          bounty
            .slice(0)
            .reverse()
            .map((b) => {
              return (
                <BountyTile
                  key={b._id}
                  bounty={b}
                  admin={user.user.isAdmin}
                />
              );
            })
        ) : (
          <div className={style.Center} style={{ fontWeight: '500' }}>
            No bounty found!
          </div>
        )}
      </div>
    </>
  );
};

export default Bounties;
